import React from 'react';
import PropTypes from 'prop-types';

import FinanceMainSection from '@/components/ErrorPage/MainSection/Finance';

export function MinfinMainSection({ resource }) {
  return <FinanceMainSection resource={resource} />;
}
MinfinMainSection.propTypes = {
  resource: PropTypes.string.isRequired,
};

export default MinfinMainSection;
